(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["section-heading"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__sectionHeadingObserverInitialized) return;
    window.__sectionHeadingObserverInitialized = true;

    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-section-heading]').forEach((el) => {
        el.classList.add('section-heading--visible');
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('section-heading--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.25 }
    );

    document.querySelectorAll('[data-section-heading]').forEach((el) => observer.observe(el));
  })();
  } catch(e) { console.error(e); }
})();

})();
